export default "__VITE_ASSET___k2i0oMI__"